import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.menu_api.menus;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// default cache 5min 
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'menu_api',
  group: 'menus',
  defaultTtl: '5m',
  hashLargeSegments: true,
  emitMeta: true,
});


export const getMenuPdfByLocalId = async (localId: number) => { // 20 min cache
  return await cachedApi.get(`/GetMenuPdfByLocalId/${localId}`, undefined, { ttl: '20m' });
}


// get al menus by local id
export const getMenusByLocalId = async (localId: number) => { // 20 min cache
  return await cachedApi.get(`/GetMenusByLocalId/${localId}`, undefined, { ttl: '20m' });
};

//Get mapped menu structure
export const getBuiltMenusByLocalId = async (localId: number, isDelivery: boolean = false) => { // 5 min cache
  return await cachedApi.post(`/GetBuiltMenusByLocalId/${localId}`, { isDelivery });
};





// GetBuiltMenuByMenuIdV2/<int:menu_id>

export const getBuiltMenuByMenuIdV2 = async (menuId: number) => { // 5 min cache
  return await cachedApi.get(`/GetBuiltMenuByMenuIdV2/${menuId}`);
};

// /GetAllBuiltMenusByLocalIdV2/<int:local_id>

export const getAllBuiltMenusByLocalIdV2 = async (localId: number, pedido_type: string, include_images: boolean = false, third_party_provider_id?: number) => {
  return await cachedApi.post(`/GetAllBuiltMenusByLocalIdV2/${localId}`, { // 5 min cache
    pedido_type,
    include_images,
    ...(third_party_provider_id != null ? { third_party_provider_id } : {}),
  });
};

// Function to create a new menu
  export const createMenuByLocalId = async (localId: number, menuData: any) => {
    const res = await api.post(`/CreateMenuByLocalId/${localId}`, menuData);
    await cachedApi.clear();
    return res;
  };

  export const createMenuWithCategoriesByLocalId = async (
    localId: number,
    menuData: {
      menu_name: string;
      menu_description: string;
      state?: boolean;
      category_ids: number[];
    }
  ) => {
    const res = await api.post(
      `/CreateMenuWithCategoriesByLocalId/${localId}`,
      menuData
    );
    await cachedApi.clear();
    return res;
  };
  
  // Function to update an existing menu
  /**
   * update_menu_parser = reqparse.RequestParser()
update_menu_parser.add_argument('menu_name', type=str, required=False, help='Name of the menu', location='json')
update_menu_parser.add_argument('menu_description', type=str, required=False, help='Description of the menu', location='json')
update_menu_parser.add_argument('local_id', type=int, required=False, help='Local ID associated with the menu', location='json')
update_menu_parser.add_argument('state', type=bool, required=False, help='State of the menu', location='json')
update_menu_parser.add_argument('schedule', type=dict, required=False, help='Menu schedule configuration', location='json')
update_menu_parser.add_argument('delete_schedule', type=bool, required=False, help='Set to true to remove the schedule from the menu', location='json')

@ns.route('/UpdateMenu/<int:menu_id>')
@ns.param('menu_id', 'The menu identifier')
class UpdateMenu(Resource):
    @ns.doc('update_menu',security='bearerAuth')
    @ns.expect(update_menu_parser)
    @jwt_required()
    def put(self, menu_id):
        '''Update an existing menu'''
        data = update_menu_parser.parse_args()
        menu = Menu.query.get(menu_id)

        if not menu:
            ns.abort(404, 'Menu no encontrado o no existe')

        # Update basic fields
        if data['menu_name']:
            menu.menu_name = data['menu_name']
        if data['menu_description']:
            menu.menu_description = data['menu_description']
        if data['local_id']:
            menu.local_id = data['local_id']
        if data['state'] is not None:
            menu.state = data['state']
        
        # Handle schedule deletion
        if data.get('delete_schedule'):
            try:
                menu.schedule = None
                db.session.commit()
                return {
                    'message': 'Menu actualizado con exito',
                    'schedule_removed': True
                }, 200
            except Exception as e:
                db.session.rollback()
                return {
                    'message': 'Error eliminando el schedule del menu',
                    'error': str(e)
                }, 500
        
        # Handle schedule update using MenuHelper
        if data.get('schedule'):
            try:
                helper = MenuHelper(menu_id=menu_id)
                success, message, status = helper.update_schedule(data['schedule'])
                
                if not success:
                    return message, status
                
                # Schedule was updated successfully by helper, no need to update menu.schedule manually
                # The helper already commits the changes
                return {
                    'message': 'Menu actualizado con exito',
                    'schedule_update': message
                }, 200
                
            except Exception as e:
                db.session.rollback()
                return {
                    'message': 'Error actualizando el schedule del menu',
                    'error': str(e)
                }, 500

        try:
            db.session.commit()
            return {'message': 'Menu actualizado con exito'}, 200
        except Exception as e:
            ns.abort(500, e.__doc__, status = "No se ha podido guardar la informacion", statusCode = "500")
   */
  export const updateMenu = async (menuId:number, menuData:any) => {
    const res = await api.put(`/UpdateMenu/${menuId}`, menuData);
    await cachedApi.clear();
    return res;
  };


  export const toggleMenuState = async (menuId:number) => {
    const res = await api.put(`/ToggleMenuState/${menuId}`);
    await cachedApi.clear();
    return res;
  };
  
  // Function to delete a menu
  export const deleteMenu = async (menuId:number) => {
    const res = await api.delete(`/DeleteMenu/${menuId}`);
    await cachedApi.clear();
    return res;
  };

///AddMenuCategoryToMenu/<int:menu_id>/<int:category_id>
export const addMenuCategoryToMenu = async (menuId:number, categoryId:number) => {
  const res = await api.post(`/AddMenuCategoryToMenu/${menuId}/${categoryId}`);
  await cachedApi.clear();
  return res;
}
// /RemoveMenuCategoryFromMenu/<int:menu_id>/<int:category_id>

export const removeMenuCategoryFromMenu = async (menuId:number, categoryId:number) => {
  const res = await api.delete(`/RemoveMenuCategoryFromMenu/${menuId}/${categoryId}`);
  await cachedApi.clear();
  return res;
}

  export const DeleteMenusSelected = async (menus: string[]) => {
  const res = await api.delete('/DeleteMenusSelected');
  await cachedApi.clear();
  return res;
};


export const SetLocalMenuPdfByLocalId = async (localId: number, menu:string) => {
  const res = await api.post(`/SetLocalMenuPdfByLocalId/${localId}`, {"menu":menu}, {});
  await cachedApi.clear();
  return res;
};

export const RemoveLocalMenuPdfByLocalId = async (localId: number) => {
  const res = await api.delete(`/RemoveLocalMenuPdfByLocalId/${localId}`, {});
  await cachedApi.clear();
  return res;
};

export const initMenuDefaultByLocalId = async (localId: number) => {
  const res = await api.post(`/InitMenuDefaultByLocalId/${localId}`, {});
  await cachedApi.clear();
  return res;
};
